import * as React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled from 'styled-components';
import ErrorBoundary from 'view/error-boundary/error-boundary';
import { token } from '@atlaskit/tokens';
import {
    ForgeUIEnvironmentProvider,
    ForgeUIExtensionPointProvider,
    ProductEnvironment,
} from '@atlassian/forge-ui/provider';

import { getAnalyticsWebClientPromise } from '@atlassian/help-center-common-util/analytics/client';
import { EnvType, getEnv } from '@atlassian/help-center-common-util/env';

import type { ExtensionPointModule } from '../types';

interface Props {
    extensionType: ExtensionPointModule;
    noWrapper?: boolean;
}

const errorBoundaryId = 'jsm-forge-extension-point-provider';

const getProductEnvironment = (): ProductEnvironment => {
    const productEnvironmentMap = {
        [EnvType.LOCAL]: ProductEnvironment.DEVELOPMENT,
        [EnvType.DEV]: ProductEnvironment.DEVELOPMENT,
        [EnvType.STAGING]: ProductEnvironment.STAGING,
        [EnvType.PROD]: ProductEnvironment.PRODUCTION,
    };
    return productEnvironmentMap[getEnv().environment];
};

const ExtensionPointProviderContainerWrapper: React.FC<React.PropsWithChildren<{ noWrapper?: boolean }>> = ({
    noWrapper,
    children,
}) => (noWrapper ? <>{children}</> : <ExtensionPointProviderContainer>{children}</ExtensionPointProviderContainer>);

export const ExtensionPointProvider: React.FC<React.PropsWithChildren<Props>> = ({
    children,
    extensionType,
    noWrapper,
}) => (
    <ErrorBoundary id={errorBoundaryId} packageName={extensionType}>
        <ExtensionPointProviderContainerWrapper noWrapper={noWrapper}>
            <ForgeUIEnvironmentProvider value={getProductEnvironment()}>
                <ForgeUIExtensionPointProvider
                    analyticsWebClient={getAnalyticsWebClientPromise().then((client) => {
                        return client.getInstance();
                    })}
                    environment={getProductEnvironment()}
                    product="jira"
                    page={extensionType}
                >
                    {children}
                </ForgeUIExtensionPointProvider>
            </ForgeUIEnvironmentProvider>
        </ExtensionPointProviderContainerWrapper>
    </ErrorBoundary>
);

export default ExtensionPointProvider;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const ExtensionPointProviderContainer = styled.div`
    margin-top: ${token('space.100', '8px')};
`;
